import { request } from "services/api/util";

class ReportService {
  async getCrmMetricsProcessId(param) {
    const config = {
      method: "get",
      url: `admin/report/crmMetrics`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getCrmMetrics(param) {
    const config = {
      method: "get",
      url: `admin/report/crmMetrics/result`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getChannelsAndSources() {
    const config = {
      method: "get",
      url: `admin/report/crmMetrics/filter`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getRetentionMetricsProcessId(param) {
    const config = {
      method: "get",
      url: `admin/report/retentionMetrics`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getRetentionMetrics(param) {
    const config = {
      method: "get",
      url: `admin/report/retentionMetrics/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getReportJobs(param) {
    const config = {
      method: "get",
      url: `admin/report/job`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getRetentionProductProcessId(param) {
    const config = {
      method: "get",
      url: `admin/report/RetentionProduct/v2`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getRetentionProduct(param) {
    const config = {
      method: "get",
      url: `admin/report/RetentionProduct/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getCustomerListByPurchasedProduct(param) {
    const config = {
      method: "get",
      url: `admin/report/CustomerListByPurchasedProduct`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getSurveyReportAsync(param, id) {
    const config = {
      method: "get",
      url: `/admin/survey/${id}/report/json`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getSurveyReportExcelAsync(param, id) {
    const config = {
      method: "get",
      url: `/admin/survey/${id}/report/excel`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getSurveyReportResult(param) {
    const config = {
      method: "get",
      url: `/admin/survey/report/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async createAgeGroupReport(body) {
    return request({
      method: "post",
      url: "v1/admin/report/ageGroup",
      data: body,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    });
  }

  async getAgeGroupReportResult(param) {
    const config = {
      method: "get",
      url: `v1/admin/report/ageGroup/result`,
      params: param,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new ReportService();
